<template>
    <div class="ns-approve-forecast">
        <!-- Graph -->
        <!-- <DayForecastGraph /> -->
        <div v-if="isDataLoaded" class="ns-table-section px-5 py-6">
            <table>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>
                            Last Year
                            <p class="text-sm font-normal mt-2">{{ moment(forecastData.sale_year.date, 'YYYY-MM-DD').format('DD MMM YY, ddd') }}</p>
                        </th>
                        <th>
                            {{ 'Last Week' }}
                            <p class="text-sm font-normal mt-2">{{ moment(forecastData.sale_week.date, 'YYYY-MM-DD').format('DD MMM YY, ddd') }}</p>
                        </th>
                        <th>
                            4 Weeks Trend
                        </th>
                        <th>Forecast
                            <p class="text-sm font-normal mt-2">{{ moment(forecastData.forecast.date, 'YYYY-MM-DD').format('DD MMM YY, ddd') }}</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="ns-border-b-none">
                        <td class="font-semibold">
                            <div style="padding-left: 50px">
                                <span class="mr-4">
                                    Sales
                                </span>
                                <span>
                                    <button v-if="is_view_more" class="text-amplitude font-semibold" @click="is_view_more = false"> View More <i class="el-icon-arrow-down"></i> </button>
                                    <button v-else class="text-amplitude font-semibold" @click="is_view_more = true"> View Less <i class="el-icon-arrow-up"></i> </button>
                                </span>
                            </div>
                        </td>
                        <td class="font-semibold">&nbsp;</td>
                        <td class="font-semibold">&nbsp;</td>
                        <td class="font-semibold">&nbsp;</td>
                        <td class="font-semibold">&nbsp;</td>
                    </tr>
                    <tr :class="!is_view_more && 'ns-sf-is-ot'" class="ns-border-y-none">
                        <td>Projected</td>
                        <td class="font-semibold">{{ formattedNumber(forecastData.sale_year.amount) }}</td>
                        <td class="font-semibold">{{ formattedNumber(forecastData.sale_week.amount) }}</td>
                        <td>-</td>
                        <td  class="font-semibold">
                            {{ formattedNumber(forecastData.forecast.amount) }} 
                        </td>
                    </tr>
                    <tr :class="!is_view_more && 'ns-sf-is-ot'" class="ns-border-y-none">
                        <td>Adjusted</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td v-if="is_amount_editable" class="font-semibold flex items-center justify-center">
                            <el-input v-model="forecastData.forecast.adjusted_amount" size="mini" style="width: 95px" :min="0" :max="999999" @input="allowNumbersOnly('amount')" @change="$emit('updateAdjSales', forecastData.forecast.amount)" ></el-input>
                            <span  class="ml-2"> {{ percentageDiff(forecastData.forecast.adjusted_amount, forecastData.forecast.amount) + '%' }} - Adjusted</span>
                            <div class="ml-4">
                                <el-button size="mini" @click="updateValues('amount', 'cancel');">Cancel</el-button>
                                <el-button size="mini" class="ns-button" @click="updateValues('amount', 'update')">OK</el-button>
                            </div>
                        </td>
                        <td v-else class="font-semibold">
                            {{ formattedNumber(forecastData.forecast.adjusted_amount) }}
                            <span  class="ml-2"> {{ percentageDiff(forecastData.forecast.adjusted_amount, forecastData.forecast.amount) + '%' }} - Adjusted</span>
                            <i v-if="isEditable" class="el-icon-edit text-amplitude font-semibold text-lg ml-4 cursor-pointer" @click="updateValues('amount', 'edit');"></i>
                        </td>
                    </tr>
                    <template v-if="!is_view_more">
                        <tr v-for="i_data in orderTypeData.keys" :key="i_data" class="ns-sf--order-type">
                            <td>{{ i_data }}</td>
                            <td>
                                <span v-if="Object.keys(orderTypeData.sale_year).length && orderTypeData.sale_year[i_data]">
                                    {{ formattedNumber(orderTypeData.sale_year[i_data]) }}
                                </span>
                                <span v-else> - </span>
                            </td>
                            <td>
                                <span v-if="Object.keys(orderTypeData.sale_week).length && orderTypeData.sale_week[i_data]">
                                    {{ formattedNumber(orderTypeData.sale_week[i_data]) }}
                                </span>
                                <span v-else> - </span>
                            </td>
                            <!-- <td>{{ Object.keys(orderTypeData.sale_week).length ? orderTypeData.sale_week[i_data] : '-' }}</td> -->
                            <td>-</td>
                            <td>
                                <span v-if="Object.keys(orderTypeData.forecast).length && orderTypeData.forecast[i_data]">
                                    {{ formattedNumber(orderTypeData.forecast[i_data]) }}
                                </span>
                                <span v-else> - </span>
                            </td>
                            <!-- <td>{{ Object.keys(orderTypeData.forecast).length ? orderTypeData.forecast[i_data] : '-' }}</td> -->
                        </tr>
                    </template>
                    
                    <tr class="ns-border-b-none">
                        <td class="font-semibold">Transactions</td>
                        <td class="font-semibold">&nbsp;</td>
                        <td class="font-semibold">&nbsp;</td>
                        <td class="font-semibold">&nbsp;</td>
                        <td class="font-semibold">&nbsp;</td>
                    </tr>
                    <tr class="ns-border-y-none">
                        <td>Projected</td>
                        <td class="font-semibold">{{ forecastData.sale_year.sales }}</td>
                        <td class="font-semibold">{{ forecastData.sale_week.sales }}</td>
                        <td class="font-semibold">{{ forecastData.trend.trend_transactions }}</td>
                        <td class="font-semibold">{{ forecastData.forecast.sales }} </td>
                    </tr>
                    <tr class="ns-border-t-none">
                        <td>Adjusted</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td v-if="is_qty_editable" class="font-semibold flex items-center justify-center">
                            <el-input v-model="forecastData.forecast.adjusted_quantity" size="mini" style="width: 95px" :min="0" :max="999999" @input="allowNumbersOnly('adjusted_quantity')" @change="$emit('updateAdjTrx', forecastData.forecast.adjusted_quantity)" ></el-input>
                            <span  class="ml-2">{{ percentageDiff(forecastData.forecast.adjusted_quantity, forecastData.forecast.sales) + '%' }} - Adjusted</span>
                            <!-- :class="[forecastData.forecast.sales < forecastData.forecast.adjusted_quantity ? 'text-green' : forecastData.forecast.sales > forecastData.forecast.adjusted_quantity ? 'text-red' : '']" -->
                            <div class="ml-4">
                                <el-button size="mini" @click="updateValues('qty', 'cancel');">Cancel</el-button>
                                <el-button size="mini" class="ns-button" @click="updateValues('qty', 'update')">OK</el-button>
                            </div>
                        </td>
                        <td v-else class="font-semibold">
                            {{ forecastData.forecast.adjusted_quantity }} 
                            <span  class="ml-2">{{ percentageDiff(forecastData.forecast.adjusted_quantity, forecastData.forecast.sales) + '%' }} - Adjusted</span>
                            <i v-if="isEditable && !checkCompany.is_bt" class="el-icon-edit text-amplitude font-semibold text-lg ml-4 cursor-pointer" @click="updateValues('qty', 'edit');"></i>
                        </td>
                    </tr>

                    <tr class="ns-border-b-none">
                        <td class="font-semibold">Events</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>
                            <el-button class="ns-button" @click="addEvent" icon="el-icon-circle-plus-outline" type="text">Add Event</el-button>
                        </td>
                    </tr>
                    <tr class="ns-border-y-none">
                        <td>Internal</td>
                        <td>
                            <div>-</div>
                        </td>
                        <td>-</td>
                        <td>
                            <div>-</div>
                        </td>
                        <td>
                            <div v-if="eventsData.internal.length">
                                <ol>
                                    <li v-for="(item, index) in eventsData.internal.slice(0, 3)" :key="index"
                                        class="py-2 flex items-center justify-center" @click="setEvent(item.id)">
                                        <p class="text-sm font-semibold text-amplitude cursor-pointer text-left truncate"  style="width: fit-content; max-width: 250px;">{{ item.name }}</p>
                                        <img src="../../../assets/icons/edit-icon.svg" alt="Edit" class="ml-2 cursor-pointer" width="15px"  @click="setEvent(item.id)" srcset="">
                                    </li>
                                    <template v-if="eventsData.internal.length > 3">
                                        <el-popover
                                        placement="top-start"
                                        width="700"
                                        trigger="hover">
                                            <div class="ns-sf--events-pp">
                                                <el-table :data="eventsData.internal.slice(3)">
                                                    <el-table-column label="Event Name" prop="name" header-align="left" align="left">
                                                        <template slot-scope="scope">
                                                            <div class="py-2 text-sm cursor-pointer">
                                                            {{ scope.row.name }}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Action" width="100" header-align="left" align="left">
                                                        <template slot-scope="scope">
                                                            <img
                                                            src="../../../assets/icons/edit-icon.svg"
                                                            alt="Edit"
                                                            class="ml-2 cursor-pointer"
                                                            width="15px"
                                                            @click="setEvent(scope.row.id)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                                <el-tag slot="reference" class="ns-tag cursor-pointer">+ {{ eventsData.internal.length - 3 }}</el-tag>
                                            </el-popover>
                                    </template>
                                </ol>
                            </div>
                            <div v-else> - </div>
                        </td>
                    </tr>
                    <tr class="ns-border-t-none">
                        <td>External</td>
                        <td>
                           <div>-</div>
                        </td>
                        <td>
                            <div>-</div>
                        </td>
                        <td>-</td>
                        <td>
                            <div v-if="eventsData.external.length">
                                <ol>
                                    <li v-for="(item, index) in eventsData.external.slice(0, 3)" :key="index"
                                        class="py-2 flex items-center justify-center" @click="setEvent(item.id)">
                                        <p class="text-sm font-semibold text-amplitude cursor-pointer text-left truncate"  style="width: fit-content; max-width: 250px;">{{ item.name }}</p>
                                        <img src="../../../assets/icons/edit-icon.svg" alt="Edit" class="ml-2 cursor-pointer" width="15px"  @click="setEvent(item.id)" srcset="">
                                    </li>
                                    <template v-if="eventsData.external.length > 3">
                                        <el-popover
                                        placement="top-start"
                                        width="700"
                                        trigger="hover">
                                            <div class="ns-sf--events-pp">
                                                <el-table :data="eventsData.external.slice(3)">
                                                    <el-table-column label="Event Name" prop="name" header-align="left" align="left">
                                                        <template slot-scope="scope">
                                                            <div class="py-2 text-sm font-semibold text-amplitude cursor-pointer">
                                                            {{ scope.row.name }}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Action" width="100" header-align="left" align="left">
                                                        <template slot-scope="scope">
                                                            <img
                                                            src="../../../assets/icons/edit-icon.svg"
                                                            alt="Edit"
                                                            class="ml-2"
                                                            width="15px"
                                                            @click="setEvent(scope.row.id)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                                <el-tag slot="reference" class="ns-tag cursor-pointer">+ {{ eventsData.external.length - 3 }}</el-tag>
                                            </el-popover>
                                    </template>
                                </ol>
                            </div>
                            <div v-else> - </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="font-semibold">Weather</td>
                        <td class="font-semibold">
                            <div class="flex items-center justify-center">
                                <span>{{ forecastData.sale_year.temp_min + '°C / ' + forecastData.sale_year.temp_max + '°C' }}</span>
                                <img id="wicon" class="ml-2" width="35px" :src="weatherIconClass(forecastData.sale_year.weather_icon)" alt="Weather icon">
                                <span class="text-xs">{{forecastData.sale_year.weather}}</span>
                            </div>
                        </td>
                        <td class="font-semibold">
                            <div class="flex items-center justify-center">
                                <span>{{ forecastData.sale_week.temp_min + '°C / ' + forecastData.sale_week.temp_max + '°C' }}</span>
                                <img id="wicon" class="ml-2" width="35px" :src="weatherIconClass(forecastData.sale_week.weather_icon)" alt="Weather icon">
                                <span class="text-xs">{{forecastData.sale_week.weather}}</span>
                            </div>
                        </td>
                        <td>-</td>
                        <td class="font-semibold">
                            <div class="flex items-center justify-center">
                                <span>{{ forecastData.forecast.temp_min + '°C / ' + forecastData.forecast.temp_max + '°C' }}</span>
                                <img id="wicon" class="ml-2" width="35px" :src="weatherIconClass(forecastData.forecast.weather_icon)" alt="Weather icon">
                                <span class="text-xs">{{forecastData.forecast.weather}}</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- add Event section -->
        <el-dialog title="Add Event" :visible.sync="addEventVisible" width="60%"
            custom-class="ns-dialog ns-sf-event-pp">
            <el-row :gutter="20" class="my-3">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">Event Name <span style="color: red">*</span></p>
                    <!-- v-validate="'max:20' || 'required'" -->
                    <BaseInput v-model="event_name" v-validate="addEventVisible ? 'required' : ''" class="baseInput"
                        style="width: 100%" custom-class="text-sm  text-amp-input-boxes" type="text" name="eventName" />
                    <p>
                        <span :v-show="errors.has(`eventName`)" class="text-red-dark text-xs">
                            {{ errors.first(`eventName`) ? 'Required field' : '' }}
                        </span>
                    </p>
                </el-col>
            </el-row>

            <el-row :gutter="20" class="my-3">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">Event Type <span style="color: red">*</span></p>
                    <el-select v-model="event_type" v-validate="addEventVisible ? 'required' : ''" name="eventType"
                        style="width: 100%" placeholder="Event Type" @change="eventType(event_type)">
                        <el-option v-for="(item, index) in eventTypeList" :key="index" :value="item.value"
                            :label="item.name">
                            {{ item.name }}
                        </el-option>
                    </el-select>
                    <p>
                        <span :v-show="errors.has(`eventType`)" class="text-red-dark text-xs">
                            {{ errors.first(`eventType`) ? 'Required field' : '' }}
                        </span>
                    </p>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">Event Category <span style="color: red">*</span></p>
                    <el-select v-model="event_category" v-validate="addEventVisible ? 'required' : ''" :disabled="!event_type" name="event Category"
                        style="width: 100%" placeholder="Event Category">
                        <el-option v-for="(item, index) in allEventCategories" :key="index" :value="item.id"
                            :label="item.name">
                            {{ item.name }}
                        </el-option>
                    </el-select>
                    <p>
                        <span :v-show="errors.has(`event Category`)" class="text-red-dark text-xs">
                            {{ errors.first(`event Category`) ? 'Required field' : '' }}
                        </span>
                    </p>
                </el-col>
            </el-row>

            <el-row :gutter="20" class="my-3">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">From <span style="color: red">*</span></p>
                    <el-date-picker v-model="startDateEvent" v-validate="addEventVisible ? 'required' : ''"
                        style="width: 100%" type="date" placeholder="Start Date" name="from date"
                        :picker-options="dateRangeOptions" @change="getOriginalForecast()"></el-date-picker>
                    <p>
                        <span :v-show="errors.has(`from date`)" class="text-red-dark text-xs">
                            {{ errors.first(`from date`) ? 'Required field' : '' }}
                        </span>
                    </p>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">End Date <span style="color: red">*</span></p>
                    <el-date-picker v-model="endDateEvent" v-validate="addEventVisible ? 'required' : ''"
                        style="width: 100%" type="date" placeholder="End Date" :picker-options="{
                            disabledDate: (date) => {
                                return date < startDateEvent;
                            },
                            firstDayOfWeek: 1,
                        }" :disabled="!startDateEvent" name="to date" @change="getOriginalForecast()"></el-date-picker>
                    <p>
                        <span :v-show="errors.has(`to date`)" class="text-red-dark text-xs">
                            {{ errors.first(`to date`) ? 'Required field' : '' }}
                        </span>
                    </p>
                </el-col>
            </el-row>

            <!-- <el-row :gutter="20" class="my-3">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">Start Time</p>
                    <el-time-select v-model="Start_time_event" :editable="false" style="width: 100%" :picker-options="{
                        start: '00:00',
                        step: '00:30',
                        end: '23:59',
                    }" placeholder="Start Time" :disabled="event_type == 'store_closed'" @change="updateEndTimeOptions">
                    </el-time-select>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">End Time</p>
                    <el-time-select v-model="end_time_event" :editable="false" style="width: 100%" :picker-options="end_time_options" placeholder="Start Time" :disabled="event_type == 'store_closed' || !Start_time_event">
                    </el-time-select>
                </el-col>
            </el-row> -->

            <el-row :gutter="20" class="my-3">
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <p class="py-2">Sales Impact <span style="color: red">*</span></p>
                    <div class="flex items-center">
                        <el-select v-model="sales_impact" v-validate="addEventVisible ? 'required' : ''"  style="width: 100%" name="Sales Impact" placeholder="Sales Impact"
                            :filterabe="true" @change="changeSalesImpact(sales_impact, $event)">
                            <el-option v-for="(item, itemIndex) in sales_impact_list" :key="itemIndex" :label="item.title"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <span :v-show="errors.has(`Sales Impact`)" class="text-red-dark text-xs">
                        {{ errors.first(`Sales Impact`) ? 'Required field' : '' }}
                    </span>
                </el-col>
            </el-row>

            <div class="text-right pt-2">
                <div v-if="eventId != ''" class="flex justify-end">
                    <BaseButton type="submit" class="w-24 mr-4" :disabled="is_event_loading" buttonclass="btn p-2 text-xs " @click="deleteEvent">
                        Delete
                    </BaseButton>
                    <BaseButton type="submit" class="w-24" :disabled="is_event_loading" buttonclass="btn p-2 text-xs " @click="updateEvent">
                        Update
                    </BaseButton>
                </div>
                <div v-else class="flex justify-end">
                    <BaseButton type="submit" class="w-24 mr-4" buttonclass="btn p-2 text-xs "
                        @click="addEventVisible = false">
                        Cancel
                    </BaseButton>
                    <BaseButton type="submit" class="w-24" :disabled="is_event_loading" buttonclass="btn p-2 text-xs " @click="createNewEvent">
                        Add
                    </BaseButton>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import DayForecastGraph from "../graphs/DayForecastGraph.vue"
import api from "../../../services/labourPalnningService.js";
import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { EventBus } from '../../../eventBus';
export default {
    name: "ApproveForecast",
    components: {
        DayForecastGraph
    },
    props: {
        forecastData: {
            type: Object,
            default: () => { }
        },
        forecastDataClone: {
            type: Object,
            default: () => { }
        },
        selectedDate: {
            type: String,
            default: () => '-'
        },
        isDataLoaded: {
            type: Boolean,
            default: () => false
        },
        allEvents: {
            type: Array,
            default: () => []
        },
        eventCategories: {
            type: Array,
            default: () => []
        },
        formattedDay: {
            type: String,
            default: () => ''
        },
        approveDatesList: {
            type: Array,
            default: () => []
        },
        storeName: {
            type: String,
            default: () => ''
        },
    },
    data() {
        return {
            moment,
            is_view_more: true,
            addEventVisible: false,
            event_name: null,
            event_type: null,
            event_category: null,
            startDateEvent: null,
            endDateEvent: null,
            Start_time_event: '00:00:00',
            end_time_event: '00:00:00',
            sales_impact: null,
            original_forecast: null,
            updated_forecast: null,
            eventId: null,
            city: '',
            eventTypeList: [
                {
                    name: "Internal",
                    value: "internal",
                },
                {
                    name: "External",
                    value: "external",
                },
            ],
            sales_impact_list: [],
            is_edit_adj_trx: false,
            adjusted_trx: 0,
            dateRangeOptions: {
                firstDayOfWeek: 1,
            },
            selected_approve_date:this.selectedDate,
            is_event_loading: false,
            end_time_options: {
                start: '00:00',
                step: '00:30',
                end: '23:59',
            },
            is_amount_editable: false,
            is_qty_editable: false,
        }
    },
    computed: {
        ...mapState("SalesForecastStore", [
            "stores_list",
        ]),
        ...mapState("salesForecastStoreV2", [
                "old_amount",
            ]),
        ...mapState("CommonStore", ["companyData"]),
        checkCompany(){
            let data = JSON.parse(localStorage.getItem('check_company'));
            let obj = {
                        is_sb_malaysia: false,
                        is_kfc: false,
                        is_mcd: false,
                        is_bk: false,
                        is_bkasia: false,
                        is_mcd_north: false,
                        is_demo: false,
                        is_bt: false,
                        is_bb: false,
                        is_dominos: false,
                        is_gf: false,
                        is_sb_india: false,
                    };
            if(!data){
                const get_comp = process.env.VUE_COMPANY_NAME;
                if(get_comp){
                obj[get_comp] = true
                }
                data = obj;
                // console.log(obj, 'process.env.VUE_COMPANY_NAME');
            }
            return data;
        },
        allEventCategories(){
            let all_event_cat = [...this.eventCategories];
            if(this.event_type){
                console.log()
                all_event_cat = all_event_cat.filter((e) => e.type.toLowerCase() === this.event_type.toLowerCase());
            }
            return all_event_cat;
        },
		currency() {
			return this.companyData.currency ? ( ' ' + this.companyData.currency) : "";
		},
		selectedStore() {
			return localStorage.getItem('store') || localStorage.getItem('store_id');
		},
        lastYearDate(){
            return moment(this.selectedDate, 'YYYY-MM-DD').subtract(1, 'year').format('Do MMMM YYYY, dddd');
        },
        lastMondayDate(){
            return moment(this.selectedDate, 'YYYY-MM-DD').clone().subtract(7, 'days').isoWeekday(moment(this.selectedDate, 'YYYY-MM-DD').day()).format('Do MMMM YYYY, dddd');
        },
        lastFourWeekDate(){
            return moment(this.selectedDate, 'YYYY-MM-DD').clone().subtract(4, 'weeks').format('Do MMMM YYYY, dddd');
        },
        eventsData(){
            let events = [...this.allEvents];
            let result = {internal: [], external: []};
            const getEventType = (id) => {
                return this.eventCategories.find((e) => e.id === id).type;
            }
            events.forEach(event => {
                if(getEventType(event.category) === 'Internal' || getEventType(event.category) === 'internal'){
                    result.internal.push(event);
                }else{
                    result.external.push(event);
                }
            });
            return result;
        },
        orderTypeData(){
            function processData(data, is_for){
                let result = {};
                for (const key in data) {
                    if (Object.hasOwnProperty.call(data, key)) {
                        const element = data[key];
                        result[key] = element;
                        // result.push({
                        //     is_for: is_for,
                        //     key: key,
                        //     value: element
                        // })
                    }
                }
                return result;
            }

            let forecast = processData(this.forecastData.forecast.order_type, 'forecast');
            let sale_year = processData(this.forecastData.sale_year.order_type, 'sale_year');
            let sale_week = processData(this.forecastData.sale_week.order_type, 'sale_week');
            let keys = [...new Set([...Object.keys(forecast), ...Object.keys(sale_year), ...Object.keys(sale_week)])];

            return {
                keys: keys,
                forecast: forecast,
                sale_year: sale_year,
                sale_week: sale_week
            };
        },
        isEditable(){
            const configApiData = JSON.parse(localStorage.getItem('company_config'))
            console.log(configApiData, 'configApiData')
            const enableWithin = configApiData.config.allow_transaction_sales_edit_till_time;
            const enableFrom = configApiData.config.allow_transaction_sales_edit_till_days;
            const today = moment().format('YYYY-MM-DD');
            const currTime = moment().format('HH:mm:ss');
            let selected_ap_condition = null;
			if(enableFrom >= 0) {
                selected_ap_condition = moment(this.selectedDate, 'YYYY-MM-DD').isSame(moment(today, 'YYYY-MM-DD').add(enableFrom, 'days'));
            } else if(enableFrom < 0) {
                selected_ap_condition = moment(this.selectedDate, 'YYYY-MM-DD').isSame(moment(today, 'YYYY-MM-DD').subtract(Math.abs(enableFrom), 'days'));
            }

            if(selected_ap_condition) {
				if(enableFrom >= 0) {
					return moment(this.selectedDate, 'YYYY-MM-DD').isSameOrAfter(moment(today, 'YYYY-MM-DD').add(enableFrom, 'days')) && moment(currTime, 'HH:mm:ss').isSameOrBefore(moment(enableWithin, 'HH:mm:ss'));
				} else if(enableFrom < 0) {
					return moment(this.selectedDate, 'YYYY-MM-DD').isSameOrAfter(moment(today, 'YYYY-MM-DD').subtract(Math.abs(enableFrom), 'days')) && moment(currTime, 'HH:mm:ss').isSameOrBefore(moment(enableWithin, 'HH:mm:ss'));
				}
			} else {
				if(enableFrom >= 0) {
					return moment(this.selectedDate, 'YYYY-MM-DD').isSameOrAfter(moment(today, 'YYYY-MM-DD').add(enableFrom, 'days'));
				} else if(enableFrom < 0) {
					return moment(this.selectedDate, 'YYYY-MM-DD').isSameOrAfter(moment(today, 'YYYY-MM-DD').subtract(Math.abs(enableFrom), 'days'));
				}
			}
            return false;
        }
    },
    created() {
        for (let x = -100; x <= 101; x++) {
            if (x % 5 == 0) {
                let obj = {};
                obj.title = x + "%";
                obj.value = x;
                this.sales_impact_list.push(obj);
            }
        }
    },
    mounted() {
        this.getEventsAction({
            store_id: this.selectedStore,
            date: this.selectedDate
        });
        // Set updated amount value forecastData
        // EventBus.$emit('updateAdjSales', this.forecastData.forecast.amount);
    },
    methods: {
        ...mapActions("SalesForecastStore", ["loadEventsDataAction", "loadApproveForecastData"]),
        ...mapActions("salesForecastStoreV2", ["getEventsAction"]),
        weatherIconClass(code) {
            return `http://openweathermap.org/img/w/${code}.png`;
        },
        formattedNumber(number) {
            const formatter = new Intl.NumberFormat("en-IN");
            return `${this.currency} ${formatter.format(number)} /-`;
        },
        updateEndTimeOptions() {
            if (this.Start_time_event) {
                const startTime = new Date(`2000-01-01T${this.Start_time_event}`);
                startTime.setMinutes(startTime.getMinutes() + 30);
                const startTimeFormatted = startTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                this.end_time_options = {
                    start: startTimeFormatted,
                    step: '00:30',
                    end: '23:59',
                };
            }
        },
        addEvent() {
            this.eventId = '';
            this.eventId = '';
            this.event_name = '';
            this.event_type = '';
            this.event_category = '';
            this.startDateEvent = this.selectedDate;
            this.endDateEvent = this.selectedDate;
            this.Start_time_event = '00:00:00';
            this.end_time_event = '00:00:00';
            this.sales_impact = '';
            this.original_forecast = 0;
            this.updated_forecast = 0;
            this.addEventVisible = true;
        },
        setEvent(id) {
            let eventData = this.allEvents.find((e) => e.id === id);
            this.eventId = eventData.id;
            this.event_name = eventData.name;
            this.event_type = this.eventCategories.find((e)=>e.id === eventData.category).type ;
            this.event_category = eventData.category;
            this.startDateEvent = eventData.start_date;
            this.endDateEvent = eventData.end_date;
            this.Start_time_event = eventData.start_time;
            this.end_time_event = eventData.end_time;
            this.sales_impact = eventData.impact_sales;
            this.original_forecast = 0;
            this.updated_forecast = 0;
            this.addEventVisible = true;
        },
        getSalesImpact(id) {
            let eventData = '';
            if(this.allEvents.length) {
                eventData = this.allEvents.find((e) => e.id === id);
                eventData = eventData.impact_sales
            }
            return eventData;
        },
        eventType() {
            this.eventCategories
        },
        getOriginalForecast() {

        },
        updateValues(where, action) {
            // Optmized code


            // Old code
            if(action === 'update'){
                if(where == 'amount'){
                    this.is_amount_editable = false;
                }
                if(where == 'qty'){
                    console.log(where, action, 'where, action');
                    this.is_qty_editable = false;
                }
            } else if (action === 'cancel') {
                if(where == 'amount'){
                    this.is_amount_editable = false;
                    this.forecastData.forecast.adjusted_amount = this.forecastDataClone.forecast.adjusted_amount;
                }else if(where == 'qty'){
                    this.is_qty_editable = false;
                    this.forecastData.forecast.adjusted_quantity = this.forecastDataClone.forecast.adjusted_quantity;
                }
            } else if(action === 'edit'){
                if(where == 'amount'){
                    this.is_amount_editable = true;
                    this.is_qty_editable = false;
                    this.forecastData.forecast.adjusted_quantity = this.forecastDataClone.forecast.adjusted_quantity;
                }else if(where == 'qty'){
                    this.is_qty_editable = true;
                    this.is_amount_editable = false;
                    this.forecastData.forecast.adjusted_amount = this.forecastDataClone.forecast.adjusted_amount;
                }
            }
            this.$store.commit('salesForecastStoreV2/HANDLE_APPROVE_ACTION', this.is_qty_editable || this.is_amount_editable);
        },
        changeSalesImpact(event) {
            this.sales_impact = event;
        },
        percentageDiff(adjusted_transactions, forecast_transactions){
            if(forecast_transactions == 0 || forecast_transactions == null){
                return 0;
            }
            return (((adjusted_transactions - forecast_transactions)/forecast_transactions)*100).toFixed(1);
        },
        deleteEvent() {
            let id = this.eventId;
            this.is_event_loading = true;
            api.deleteEvent(id)
                .then((response) => {
                    if (response.status === 204) {
                        this.addEventVisible = false;
                        // Call Event API
                        // this.loadEventsDataAction();
                        // this.loadApproveForecastData();
                        this.eventId = "";
                        this.$notify.success({
                            title: "Delete",
                            message: "Event Deleted Successfully",
                        });
                    }

                    this.getEventsAction({
                        store_id: this.selectedStore,
                        date: this.selectedDate
                    });
                    this.is_event_loading = false;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        updateEvent() {
            let id = this.eventId;
            let params = {
                city: this.city,
                outlet: this.selectedStore,
                name: this.event_name,
                // type: this.event_type,
                category: this.event_category,
                start_date: this.startDateEvent,
                end_date:  this.endDateEvent,
                start_time:  this.Start_time_event,
                end_time:  this.end_time_event,
                regions: [],
                subregions: [],
                stores: [{id:this.selectedStore}],
                description: ' ',
                // rank: 1,
                impact_sales: this.sales_impact,
            };
            this.is_event_loading = true;
            api.updateEvent(params, id)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        let res = JSON.parse(response.data);
                        this.addEventVisible = false;
                        // this.loadEventsDataAction();
                        // this.loadApproveForecastData();
                        this.eventId = "";
                        this.$notify.success({
                            title: "Success",
                            message: "Event Updated Successfully",
                        });
                    }

                    this.getEventsAction({
                        store_id: this.selectedStore,
                        date: this.selectedDate
                    });
                    this.is_event_loading = false;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        allowNumbersOnly(key){
            // console.log(this.forecastData.forecast.adjusted_quantity, 'newValue');
            this.forecastData.forecast[key] = this.forecastData.forecast[key].replace(/\D/g, '');
            // this.forecastData.forecast.adjusted_quantity = newValue;
        },
        createNewEvent() {
            let params = {
                name: this.event_name
                    .toLowerCase()
                    .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase())),
                start_date: moment(this.startDateEvent).format("YYYY-MM-DD"),
                end_date: moment(this.endDateEvent).format("YYYY-MM-DD"),
                start_time: this.Start_time_event,
                end_time: this.end_time_event,
                countries: [],
                regions: [],
                subregions: [],
                stores: [{ id: this.selectedStore }],
                category: this.event_category,
                description: ' ',
                impact_sales: this.sales_impact,
            };

            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.is_event_loading = true;
                    api.createNewEvent(params)
                        .then((response) => {
                            if (response.status === 201) {
                                let res = JSON.parse(response.data);
                                this.addEventVisible = false;
                                // this.loadEventsDataAction();
                                // this.loadApproveForecastData();
                                this.$notify.success({
                                    title: "Success",
                                    message: "Event Created Successfully",
                                });
                            }
                            this.getEventsAction({
                                store_id: this.selectedStore,
                                date: this.selectedDate
                            });
                            this.is_event_loading = false;
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>

.ns-table-section {
    .ns-border-y-none{
        td {
            border-bottom: none;
            border-top: none;
        }
    }
    .ns-border-b-none{
        td {
            border-bottom: none;
        }
    }
    .ns-border-t-none{
        td {
            border-top: none;
        } 
    }
    table {
        width: 100%;
        text-align: center;
        border-collapse: separate;
        border-spacing: 0;
        text-align: center;
        
        th,
        td {
            font-size: 14px;
            color: #111;
            padding: 20px 5px;
            border: 1px solid #EBEEF5;
            text-transform: capitalize;
            // text-align: left !important;
        }
        
        td:not(:first-child):not(:last-child) {
            border-left: none;
            border-right: none;
        }
        td:first-child {
            border-right: none;
        }
        td:last-child {
            border-left: none;
        }
        th:not(:first-child):not(:last-child) {
            border-left: none;
            border-right: none;
        }
        th:first-child {
            border-right: none;
        }
        th:last-child {
            border-left: none;
        }

        th {
            background: #f5f7fa;
            color: #111;
        }

        tbody tr td:first-child {
            width: 225px;
        }
    }
}

.ns-sfl-btn {
    button {
        margin: 0 auto;
    }
}
.ns-sf--order-type{
    td{
        border-top: none !important;
    }
}
.ns-sf-is-ot{
    td{
        border-bottom: none !important;
    }
}
.ns-sf--events-pp{
    max-height: 350px;
    overflow-y: auto;
}
</style>
<style>
.ns-light-button:hover{
    background: #f5b87c2e;
    color: #e29d5a;
    border-color: #e29d5a;
}
.ns-sales-forecast-by-location .el-dialog__footer{
    border-top: 1px solid #ebeef5;
    box-shadow: 0px 5px 15px rgba(153, 151, 151, 0.75);
    z-index: 999;
}
.ns-approve-forecast .ns-button{
    color: #fff;
    background: #e29d5a;
    border-color: #e29d5a;
}
.ns-approve-forecast .el-dialog__wrapper{
    background-color: #31313173;
}
.ns-sf-event-pp .el-dialog__header{
    padding: 15px !important;
    background-color: #fff !important;
    border-radius: 8px;
}
.ns-sf-event-pp .el-dialog__body{
    padding: 0px 25px 20px 25px !important;
}
.ns-sf--events-pp .cell {
    text-align: left !important;
}
.ns-sf--order-type td{
    border-bottom: none !important;
    padding: 15px !important;;
}

</style>